import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ue-expenses-edit" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "grid-table" }
const _hoisted_4 = ["data-item-idx"]
const _hoisted_5 = {
  key: 1,
  class: "readonly-text"
}
const _hoisted_6 = {
  key: 2,
  class: "readonly-text"
}
const _hoisted_7 = ["data-item-idx"]
const _hoisted_8 = {
  key: 4,
  class: "readonly-text"
}
const _hoisted_9 = {
  key: 5,
  class: "readonly-text"
}
const _hoisted_10 = ["data-item-idx"]
const _hoisted_11 = {
  key: 7,
  class: "readonly-text"
}
const _hoisted_12 = ["data-item-idx"]
const _hoisted_13 = {
  key: 9,
  class: "readonly-text"
}
const _hoisted_14 = {
  key: 10,
  class: "readonly-text"
}
const _hoisted_15 = {
  key: 11,
  class: "readonly-text",
  style: {"background-color":"var(--el-fill-color-light)","color":"var(--el-text-color-regular)"}
}
const _hoisted_16 = {
  key: 12,
  class: "readonly-text"
}
const _hoisted_17 = ["data-item-idx"]
const _hoisted_18 = {
  key: 14,
  class: "readonly-text"
}
const _hoisted_19 = {
  key: 0,
  class: "add-category-section"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_vue_loading = _resolveComponent("vue-loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.pageTitle) + " (Год: " + _toDisplayString(_ctx.formData.academicYear) + ")", 1),
          _createElementVNode("div", null, [
            _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("Назад")
              ])),
              _: 1
            }, 8, ["onClick"]),
            (_ctx.formData.status !== 'APPROVED' && (_ctx.hasAccess(_ctx.adminRoles) || _ctx.hasAccess(_ctx.managerRoles) || _ctx.hasAccess(_ctx.universityManagerRoles)))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "primary",
                  onClick: _ctx.saveData,
                  loading: _ctx.saving
                }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode("Сохранить")
                  ])),
                  _: 1
                }, 8, ["onClick", "loading"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", {
          class: "table-container",
          onPaste: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handlePaste && _ctx.handlePaste(...args))),
          onKeydown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleKeydown && _ctx.handleKeydown(...args)))
        }, [
          _createElementVNode("table", _hoisted_3, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[5] || (_cache[5] = _createElementVNode("th", null, "Категория должностей", -1)),
                _cache[6] || (_cache[6] = _createElementVNode("th", null, "Штатное кол-во работников (единиц)", -1)),
                _cache[7] || (_cache[7] = _createElementVNode("th", null, "Факт-е кол-во работников (единиц)", -1)),
                _createElementVNode("th", null, _toDisplayString(_ctx.expenseType === 'OSMS' ? 'Объект исчисления отчислений' : ((_ctx.expenseType === 'SOCIAL_TAX' || _ctx.expenseType === 'SOCIAL_DEDUCTION') ? 'Налогооблагаемый фонд оплаты труда' : 'Ежемесячный доход / Фонд оплаты')), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.expenseType === 'OPVR' ? 'Размер обязательного пенсионного взноса работодателя (%)' : (_ctx.expenseType === 'OSMS' ? 'Размер отчислений (%)' : (_ctx.expenseType === 'SOCIAL_TAX' ? 'Ставка социального налога (%)' : (_ctx.expenseType === 'SOCIAL_DEDUCTION' ? 'Ставка социальных отчислений (%)' : 'Ставка (%)')))), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.expenseType === 'OPVR' ? 'Расчетная сумма взноса' : (_ctx.expenseType === 'OSMS' ? 'Расчетная сумма отчислений на обязательное социальное медицинское страхование' : (_ctx.expenseType === 'SOCIAL_TAX' ? 'Расчетная сумма налога' : (_ctx.expenseType === 'SOCIAL_DEDUCTION' ? 'Расчетная сумма социальных отчислений' : 'Расчетная сумма')))), 1),
                _createElementVNode("th", null, _toDisplayString(_ctx.expenseType === 'OPVR' ? 'Фактическая сумма взноса' : (_ctx.expenseType === 'OSMS' ? 'Фактическая сумма отчислений на обязательное социальное медицинское страхование' : (_ctx.expenseType === 'SOCIAL_TAX' ? 'Фактическая сумма налога' : (_ctx.expenseType === 'SOCIAL_DEDUCTION' ? 'Фактическая сумма социальных отчислений' : 'Фактическая сумма')))), 1)
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.details, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: item.uuid || item.title,
                  class: _normalizeClass({'group-row': item.group, 'calculated-row': item.group && item.title === 'ВСЕГО:'})
                }, [
                  _createElementVNode("td", {
                    class: "title-cell",
                    style: _normalizeStyle(_ctx.getTitleStyle(item))
                  }, [
                    _createTextVNode(_toDisplayString(item.title) + " ", 1),
                    (item.group && item.title !== 'ВСЕГО:' && _ctx.formData.status !== 'APPROVED' && (_ctx.hasAccess(_ctx.adminRoles) || _ctx.hasAccess(_ctx.managerRoles) || _ctx.hasAccess(_ctx.universityManagerRoles)))
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "danger",
                          size: "small",
                          onClick: ($event: any) => (_ctx.removeCategory(item.categoryType))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: ['fas', 'trash'] })
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ], 4),
                  (item.group && item.title !== 'ВСЕГО:')
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 0,
                        "data-item-idx": index,
                        "data-col": "0"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.staffCount,
                          "onUpdate:modelValue": ($event: any) => ((item.staffCount) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_4))
                    : (item.group && item.title === 'ВСЕГО:')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_5, _toDisplayString(_ctx.formatInputNumber(_ctx.calculateTotalStaff()) || '0'), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_6)),
                  (item.group && item.title !== 'ВСЕГО:')
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 3,
                        "data-item-idx": index,
                        "data-col": "1"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.factCount,
                          "onUpdate:modelValue": ($event: any) => ((item.factCount) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_7))
                    : (item.group && item.title === 'ВСЕГО:')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_8, _toDisplayString(_ctx.formatInputNumber(_ctx.calculateTotalFact()) || '0'), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_9)),
                  (!item.group)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 6,
                        "data-item-idx": index,
                        "data-col": "2"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.income,
                          "onUpdate:modelValue": ($event: any) => ((item.income) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(_ctx.formatNumber(item.income)), 1)),
                  (item.group && item.title !== 'ВСЕГО:')
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 8,
                        "data-item-idx": index,
                        "data-col": "3"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.rate,
                          "onUpdate:modelValue": ($event: any) => ((item.rate) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_12))
                    : (!item.group)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_13, _toDisplayString(item.rate), 1))
                      : (_openBlock(), _createElementBlock("td", _hoisted_14)),
                  (!item.group)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_15, _toDisplayString(_ctx.formatNumber(item.calculatedSum)), 1))
                    : (_openBlock(), _createElementBlock("td", _hoisted_16, _toDisplayString(_ctx.formatNumber(item.calculatedSum)), 1)),
                  (!item.group)
                    ? (_openBlock(), _createElementBlock("td", {
                        key: 13,
                        "data-item-idx": index,
                        "data-col": "4"
                      }, [
                        _createVNode(_component_el_input, {
                          modelValue: item.actualSum,
                          "onUpdate:modelValue": ($event: any) => ((item.actualSum) = $event),
                          formatter: _ctx.formatInputNumber,
                          parser: _ctx.parseInputNumber,
                          onInput: _ctx.recalculate
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formatter", "parser", "onInput"])
                      ], 8, _hoisted_17))
                    : (_openBlock(), _createElementBlock("td", _hoisted_18, _toDisplayString(_ctx.formatNumber(item.actualSum)), 1))
                ], 2))
              }), 128))
            ])
          ])
        ], 32),
        (_ctx.formData.status !== 'APPROVED' && (_ctx.hasAccess(_ctx.adminRoles) || _ctx.hasAccess(_ctx.managerRoles) || _ctx.hasAccess(_ctx.universityManagerRoles)) && _ctx.availableCategories.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(_component_el_select, {
                modelValue: _ctx.selectedCategoryToAdd,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCategoryToAdd) = $event)),
                placeholder: "Выберите категорию",
                size: "small",
                style: {"width":"300px","margin-right":"10px"}
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableCategories, (cat) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: cat.id,
                      label: cat.title,
                      value: cat.id
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                type: "success",
                size: "small",
                onClick: _ctx.addCategory,
                disabled: !_ctx.selectedCategoryToAdd
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_font_awesome_icon, { icon: ['fas', 'plus'] }),
                  _cache[8] || (_cache[8] = _createTextVNode(" Добавить категорию "))
                ]),
                _: 1
              }, 8, ["onClick", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_vue_loading, {
      active: _ctx.isLoading,
      "is-full-page": true
    }, null, 8, ["active"])
  ]))
}